import React from "react";
import { useSpring, animated } from "react-spring";
import { useInView } from "react-intersection-observer";
import back from "../../asset/landing_images/landing-back.webp";
import left from "../../asset/landing-left.png";
import right from "../../asset/landing-right.png";

const LandingMarket = () => {
  const { ref: componentRef, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  // Spring animations for each image with slower transitions
  const backAnimation = useSpring({
    transform: inView ? "translateY(0)" : "translateY(100px)",
    opacity: inView ? 1 : 0,
    config: { duration: 1200 },
  });

  const leftAnimation = useSpring({
    transform: inView ? "translateX(0)" : "translateX(-100px)",
    opacity: inView ? 1 : 0,
    config: { duration: 1400 },
  });

  const rightAnimation = useSpring({
    transform: inView ? "translateX(0)" : "translateX(100px)",
    opacity: inView ? 1 : 0,
    config: { duration: 1600 },
  });

  // Responsive styles
  const isTabletOrMobile = window.innerWidth <= 1024;

  return (
    <div
      ref={componentRef}
      style={{
        display: "flex",
        flexDirection: isTabletOrMobile ? "column" : "row",
        justifyContent: isTabletOrMobile ? "center" : "space-evenly",
        alignItems: "center",
        textAlign: isTabletOrMobile ? "center" : "left",
        marginTop: "5rem",
        padding: isTabletOrMobile ? "0 1rem" : "0",
      }}
    >
      <div>
        <h1 style={{ color: "#000",
           marginBottom:'2rem',
           textAlign: isTabletOrMobile ? "center" : "left" }}>
          <span style={{ color: "#30CDD8", fontWeight: "bold" }}>Marketplace</span>
          : Buy, Sell, <br /> and Trade with Ease
        </h1>
        <p style={{ textAlign: isTabletOrMobile ? "center" : "left", marginTop: isTabletOrMobile ? "0" : "-1.3rem" }}>
          Explore products, post your own listings, and connect with buyers. <br />
          Filter and sort items to find exactly what you're looking for. <br />
          Manage your listings easily from your personal dashboard.
        </p>
        <a href="https://www.youthplus.ng" style={{textDecoration:'none', }} target="blank">
        <button
          style={{
            color: "#4E99DD",
            border: "2px solid #4E99DD",
            backgroundColor: "#fff",
            borderRadius: "8px",
            padding: isTabletOrMobile ? "15px" : "20px",
            marginTop: isTabletOrMobile ? "1rem" : "0",
          }}
        >
          Learn more
        </button></a>
      </div>

      <div style={{ position: "relative", alignItems: "center", marginTop: isTabletOrMobile ? "2rem" : "0" }}>
        {/* Back Image with Animation */}
        <animated.img
          src={back}
          alt="Back"
          style={{
            ...backAnimation,
            width: isTabletOrMobile ? "200px" : "310px",
            height: isTabletOrMobile ? "250px" : "400px",
            objectFit: "cover",
            borderRadius: "8px",
            margin: "5px",
          }}
        />

        {/* Left Image with Animation */}
        <animated.img
          src={left}
          alt="Left"
          style={{
            ...leftAnimation,
            width: isTabletOrMobile ? "120px" : "200px",
            height: isTabletOrMobile ? "150px" : "200px",
            objectFit: "cover",
            borderRadius: "8px",
            position: "absolute",
            top: isTabletOrMobile ? "180px" : "210px",
            left: isTabletOrMobile ? "-30px" : "-50px",
            zIndex: "2",
          }}
        />

        {/* Right Image with Animation */}
        <animated.img
          src={right}
          alt="Right"
          style={{
            ...rightAnimation,
            width: isTabletOrMobile ? "150px" : "250px",
            height: isTabletOrMobile ? "200px" : "300px",
            objectFit: "cover",
            borderRadius: "8px",
            position: "absolute",
            top: isTabletOrMobile ? "150px" : "170px",
            left: isTabletOrMobile ? "70px" : "140px",
          }}
        />
      </div>
    </div>
  );
};

export default LandingMarket;
